import CryptoJS from "crypto-js";

/**
 * วาด canvas fingerprint สำหรับ PEAK Account
 * @param {HTMLCanvasElement} canvas - Canvas element ที่จะวาด
 * @returns {string|null} hash ของ canvas fingerprint
 */
export function drawPeakAccountCanvas(canvas: HTMLCanvasElement): string | null {
  try {
    if (!canvas) return null;

    const ctx = canvas.getContext("2d");
    if (!ctx) return null;

    canvas.width = 200;
    canvas.height = 40;

    const peakColors = {
      primary: "#6c6df2", // $purple_default
      secondary: "#3297ff", // $blue_default
      accent: "#43bf76", // $green_default
      warning: "#ff9e40", // $yellow
      text: "#3b3c66", // $text
    };

    // Background
    ctx.fillStyle = "#f8f9fa";
    ctx.fillRect(0, 0, 200, 40);

    // PEAK Logo
    ctx.fillStyle = peakColors.primary;
    ctx.font = "bold 16px Arial";
    ctx.textAlign = "center";
    ctx.fillText("PEAK", 100, 15);

    // Geometric shapes
    ctx.fillStyle = peakColors.secondary;
    ctx.beginPath();
    ctx.rect(10, 20, 30, 15);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();

    ctx.beginPath();
    ctx.fillStyle = peakColors.accent;
    ctx.arc(60, 27, 12, 0, Math.PI * 2, true);
    ctx.fill();
    ctx.stroke();
    ctx.closePath();

    // PEAK Account text
    const text = "PEAK Account 2025";
    ctx.textBaseline = "alphabetic";
    ctx.font = "12px Arial";
    ctx.fillStyle = peakColors.text;
    ctx.rotate(0.02);
    ctx.fillText(text, 80, 30);

    // Business chart
    ctx.strokeStyle = peakColors.primary;
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(10, 35);
    ctx.lineTo(30, 30);
    ctx.lineTo(50, 25);
    ctx.lineTo(70, 28);
    ctx.lineTo(90, 20);
    ctx.stroke();

    // Generate SHA256 hash from canvas data
    const canvasData = canvas.toDataURL();
    const hash = CryptoJS.SHA256(canvasData);
    const hashInBase64 = CryptoJS.enc.Base64.stringify(hash);
    return hashInBase64;
  } catch (error) {
    console.error("Canvas fingerprint generation failed:", error);
    return null;
  }
}

/**
 * สร้าง canvas fingerprint hash
 * @returns {string|null} hash ของ canvas fingerprint
 */
export function generateCanvasFingerprint(): string | null {
  try {
    const canvas = document.createElement("canvas");
    return drawPeakAccountCanvas(canvas);
  } catch (error) {
    console.error("Canvas fingerprint generation failed:", error);
    return null;
  }
}
